'use client'

import { useCallback, useEffect, useState } from 'react'

import { AUTO_CLOSE_AFTER_SUCCESS_MS, RESET_PHASE_AFTER_CLOSE_MS } from './const'
import type { ShareFeedbackPhase } from './ShareFeedback.types'

type Params = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function useShareFeedbackPhase({ open, onOpenChange }: Params) {
  const [phase, setPhase] = useState<ShareFeedbackPhase>('form')

  useEffect(() => {
    if (open) return
    const timer = setTimeout(() => setPhase('form'), RESET_PHASE_AFTER_CLOSE_MS)
    return () => clearTimeout(timer)
  }, [open])

  useEffect(() => {
    if (phase !== 'success') return
    const timer = setTimeout(() => onOpenChange(false), AUTO_CLOSE_AFTER_SUCCESS_MS)
    return () => clearTimeout(timer)
  }, [phase, onOpenChange])

  const handleSubmittingChange = useCallback((submitting: boolean) => {
    if (submitting) {
      setPhase('loading')
      return
    }
    setPhase((curr) => (curr === 'success' ? 'success' : 'form'))
  }, [])

  const handleSuccess = useCallback(() => setPhase('success'), [])

  return { phase, handleSubmittingChange, handleSuccess }
}
